import { AssessmentMeasure } from "./assessment-measure";
import { AssessmentActionPlan } from "./assessment-action-plan";
import { ProjectPart } from "./project-part";

export class AssessmentObjective extends ProjectPart {
  name: string = String();
  active: boolean = true;
  sortOrder: string = "";
  objectiveData : {
    title: string,
    description: string,
    outcomeType: string;
    budgetAllocationDescription: string,
    budgetAllocationAmount: string //todo could be number??
  };
  measureList: AssessmentMeasure[] = [];
  actionPlan: AssessmentActionPlan = new AssessmentActionPlan();
  siStandardsList: standardSI[] = [];
  siGeneralEducationElementsList: any[] = [];
  siInstitutionalPrioritiesList: any[] = [];
  siStrategicInitiativesList: any[] = [];
  referenceILOGuid: string = null;
  newAddedID: number = 0;
  creationDate: string;
  isBeingEdited: boolean = false;

  titleDisabled: boolean = false;
  descriptionDisabled: boolean = false;
  editSupportedInitiatives: boolean = false;

  supportedInitiativesExpanded: boolean = false;

  constructor(
    prefix: string = "",
    id: number = 0,
    requestKey: string = "",
    name: string = "",
    active: boolean = true,
    sortOrder: string = "",
    title: string = "",
    description: string = "",
    outcomeType: string = "",
    budgetAllocationDescription: string = "",
    budgetAllocationAmount: string = "",
    measureList: AssessmentMeasure[] = [],
    siStandardsList: standardSI[] = [],
    siGeneralEducationElementsList: any[] = [],
    siInstitutionalPrioritiesList: any[] = [],
    siStrategicInitiativesList: any[] = [],
    referenceILOGuid: string = null,
    newAddedID: number = 0,
    creationDate: string = "",
    actionPlan: AssessmentActionPlan = new AssessmentActionPlan(),
    titleDisabled: boolean = false,
    descriptionDisabled: boolean = false,
    editSupportedInitiatives: boolean = false,
    expanded: boolean = true
  ) {
    super("objective", id, requestKey, expanded, prefix);
    this.name = name;
    this.active = active;
    this.sortOrder = sortOrder;
    this.objectiveData = {
      title: title,
      description: description,
      outcomeType: outcomeType,
      budgetAllocationDescription: budgetAllocationDescription,
      budgetAllocationAmount: budgetAllocationAmount
    };
    this.measureList = measureList;
    this.siStandardsList = siStandardsList;
    this.siGeneralEducationElementsList = siGeneralEducationElementsList;
    this.siInstitutionalPrioritiesList = siInstitutionalPrioritiesList;
    this.siStrategicInitiativesList = siStrategicInitiativesList;
    this.referenceILOGuid = referenceILOGuid;
    this.newAddedID = newAddedID;
    this.creationDate = creationDate;
    this.actionPlan = actionPlan;


    this.titleDisabled = titleDisabled;
    this.descriptionDisabled = descriptionDisabled;
    this.editSupportedInitiatives = editSupportedInitiatives;
  }
}

export interface standardSI {
  collection: {
    name: string,
    requestKey: string,
    id: number
  },
  element: {
    name: string
  },
  description: string,
  longDescription: string,
  expanded: boolean
}
